// extracted by mini-css-extract-plugin
export var blue = "_3u-g";
export var brand = "_3u-c";
export var darkGrey = "_3u-f";
export var disabled = "_3u-6";
export var disabledSubtle = "_3u-7";
export var error = "_3u-8";
export var green = "_3u-h";
export var grey = "_3u-e";
export var icon = "_3u-0";
export var inherit = "_3u-b";
export var lightGrey = "_3u-d";
export var orange = "_3u-j";
export var pink = "_3u-l";
export var primary = "_3u-1";
export var purple = "_3u-m";
export var quaternary = "_3u-4";
export var quinary = "_3u-5";
export var red = "_3u-k";
export var secondary = "_3u-2";
export var success = "_3u-a";
export var tertiary = "_3u-3";
export var warning = "_3u-9";
export var white = "_3u-n";
export var yellow = "_3u-i";